import React from 'react';

export class NoData extends React.Component {
  
    render() {
        return (
           <hr className="missing-data-column" />
        );
    }
}